import { render } from "./Chart.vue?vue&type=template&id=234e8004&scoped=true&ts=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"

import "./Chart.vue?vue&type=style&index=0&id=234e8004&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234e8004"]])

export default __exports__